/**
 * Number formatting follows the viewer's locale (an Indian locale gets lakh/crore grouping and
 * "12 L" / "1.2 Cr" compacts). No currency symbol: forms don't record which currency a field is in.
 */
const full = new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 })
const money = new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const compact = new Intl.NumberFormat(undefined, { notation: 'compact', maximumFractionDigits: 1 })

export const formatNumber = (value, type) => {
  if (value === null || value === undefined || value === '') return '—'
  const n = Number(value)
  return type === 'CURRENCY' ? money.format(n) : full.format(n)
}

/** Stat tiles and axis ticks: 1,284 → 1.3K (or 12.9 L in en-IN); small values stay exact. */
export const formatCompact = (value, type) => {
  if (value === null || value === undefined || value === '') return '—'
  const n = Number(value)
  return Math.abs(n) < 10_000 ? formatNumber(n, type) : compact.format(n)
}
